import React from "react";
import axios from '../../axios/axiosconf'
import { debeFiltrarPorProfesional } from '../../../utils/userAccessHelpers';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import ModalResumen from "./ModalResumen";
import ModalResumenRemision from "./ModalResumenRemision";
import { formatFecha, getFechaActual } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { Modal, Button } from "react-bootstrap";

function ModalRemisiones(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));

    const [remitidoA, setRemitidoA] = useState('');
    const [direccion, setDireccion] = useState('');
    const [telefono, setTelefono] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [fecha, setFecha] = useState(getFechaActual());
    const [fechaHora, setFechaHora] = useState('');
    const [remitidoPor, setRemitidoPor] = useState();

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [textoPieFirma, setTextoPieFirma] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    const [showModalResumen, setShowModalResumen] = useState(false);
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false);
    const [pdfNativoConfigIndividual, setPdfNativoConfigIndividual] = useState(null);
    const [pdfNativoConfigConsolidado, setPdfNativoConfigConsolidado] = useState(null);

    const [listaProfesionales, setListaProfesionales] = useState([]);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/profesionales-atencion-pacientes', config)
            .then(response => {
                if (response.status === 200) {
                    setListaProfesionales(response.data);
                }
            })
            .catch(error => console.log(error.response.data))

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const formatearFechaHoraParaInput = (fecha = new Date()) => {
        const d = fecha instanceof Date ? fecha : new Date(fecha);
        if (Number.isNaN(d.getTime())) return '';
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const h = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${day}T${h}:${min}`;
    };

    const encabezadoPdfNativoDesdeEstado = () => (
        encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? {
                izquierda: encabezadoPersonalizado.izquierda || '',
                centro: encabezadoPersonalizado.centro || '',
                derecha: encabezadoPersonalizado.derecha || ''
            }
            : null
    );

    const nombrePacienteDesdeItemRemision = (item) => {
        const sn = item.segundo_nombre ? `${item.segundo_nombre} ` : '';
        const sa = item.segundo_apellido ? item.segundo_apellido : '';
        return `${item.primer_nombre || ''} ${sn}${item.primer_apellido || ''} ${sa}`.trim() || 'Paciente no identificado';
    };

    const documentoDesdeItemRemision = (item) => {
        const t = item.tipo_documento || '';
        const n = item.numero_documento || '';
        if (t && n) return `${t} - ${n}`;
        return n || t || '—';
    };

    const valorNoAplica = (valor, fallback = 'No aplica') => {
        if (valor === null || valor === undefined) return fallback;
        const s = String(valor).trim();
        if (!s) return fallback;
        const lower = s.toLowerCase();
        if (lower === 'null' || lower === 'undefined') return fallback;
        return s;
    };

    const rellenarSeccionesPdfRemisionItem = (secciones, item) => {
        secciones.push({
            tipo: 'banner',
            titulo: 'REMISIÓN MÉDICA',
            contenido: 'REMISIÓN MÉDICA'
        });

        secciones.push({
            tipo: 'tabla-datos',
            datos: {
                filas: [{ etiqueta: 'FECHA Y HORA', valor: String(item.fecha || '') }]
            }
        });

        secciones.push({
            tipo: 'tabla-datos',
            datos: {
                filas: [
                    { etiqueta: 'REMITIDO A', valor: String(item.remitido_a || '') },
                    { etiqueta: 'ESPECIALIDAD', valor: String(item.especialidad || 'No especificada') },
                    { etiqueta: 'DIRECCIÓN', valor: String(item.direccion || 'No especificada') },
                    { etiqueta: 'TELÉFONO', valor: String(item.telefono || 'No especificado') }
                ]
            }
        });

        secciones.push({
            tipo: 'tabla-datos',
            datos: {
                filas: [
                    { etiqueta: 'REMITIDO POR', valor: String(item.profesional || '') },
                    { etiqueta: 'REGISTRO MÉDICO', valor: valorNoAplica(item.registro_medico) },
                    { etiqueta: 'CÓDIGO HABILITACIÓN', valor: valorNoAplica(item.codigo_habilitacion) }
                ]
            }
        });

        if (item.profesional && item.firma_final) {
            const firmaMetadata = item.texto_pie_firma_usuario
                ? {
                    tipo: 'profesional',
                    textoPieFirma: item.texto_pie_firma_usuario
                  }
                : {
                    tipo: 'profesional',
                    nombre: item.profesional || '',
                    registroMedico: valorNoAplica(item.registro_medico),
                    codigoHabilitacion: valorNoAplica(item.codigo_habilitacion)
                  };
            secciones.push({
                tipo: 'firma',
                imagenBase64: item.firma_final,
                metadata: firmaMetadata
            });
        }

        const descHtml = (item.descripcion && String(item.descripcion).trim())
            ? item.descripcion
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin descripción</p>';

        secciones.push({
            tipo: 'texto',
            titulo: 'DESCRIPCIÓN / MOTIVO DE REMISIÓN',
            contenido: descHtml
        });
    };

    const construirConfigPdfRemisionNativo = (item) => {
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';
        const config = {
            filename: `remision-${slug}.pdf`,
            paciente: {
                nombreCompleto: nombrePacienteDesdeItemRemision(item),
                documentoCompleto: documentoDesdeItemRemision(item)
            },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            secciones: []
        };
        rellenarSeccionesPdfRemisionItem(config.secciones, item);
        return config;
    };

    const construirConfigPdfRemisionesConsolidadoNativo = () => {
        if (!historial || historial.length === 0) return null;
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';
        const config = {
            filename: `remisiones-consolidado-${slug}.pdf`,
            paciente: {
                nombreCompleto: nombrePacienteDesdeItemRemision(historial[0]),
                documentoCompleto: documentoDesdeItemRemision(historial[0])
            },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            secciones: []
        };
        config.secciones.push({
            tipo: 'banner',
            titulo: 'REMISIONES',
            contenido: 'REMISIONES'
        });
        historial.forEach((it, index) => {
            if (index > 0) config.secciones.push({ tipo: 'salto-pagina' });
            rellenarSeccionesPdfRemisionItem(config.secciones, it);
        });
        return config;
    };

    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/remisiones', config2)
            .then(response => {
                setHistorial(response.data);

                let consolidadoItems = "";

                response.data.map((item) => {

                    let segundoNombrePaciente = item.segundo_nombre ? item.segundo_nombre + " " : "";
                    let nombrePaciente = item.primer_nombre + " " + segundoNombrePaciente + item.primer_apellido + " " + item.segundo_apellido;

                    // 🎨 USAR EL MISMO FORMATO QUE LA VISTA INDIVIDUAL - Tablas con bandas grises

                    // 1. Tabla de información del paciente y fecha
                    let segmentoInfo = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.fecha}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.tipo_documento + ' ' + item.numero_documento}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 2. Tabla de datos de la remisión
                    let segmentoDatos = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">REMITIDO A</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.remitido_a}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">ESPECIALIDAD</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.especialidad || 'No especificada'}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.direccion || 'No especificada'}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.telefono || 'No especificado'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 3. Profesional remitente + firma dinámica (firma_final / texto_pie_firma_usuario)
                    const pieFirmaHtmlItem = item.texto_pie_firma_usuario
                        ? `<div style="font-size: 10px; color: #6c757d; white-space: pre-line;">${item.texto_pie_firma_usuario}</div>`
                        : `<div style="font-size: 10px; color: #6c757d;">RM: ${valorNoAplica(item.registro_medico)} | Cód. Hab: ${valorNoAplica(item.codigo_habilitacion)}</div>`;
                    let bloqueFirmaRemitente = '';
                    if (item.profesional && item.firma_final) {
                        bloqueFirmaRemitente = `
                        <div style="margin-top: 8px;">
                            <div style="background-color: #f8f9fa; font-weight: bold; padding: 8px 10px; font-size: 13px; text-align: left; margin-bottom: 5px;">
                                FIRMA DEL PROFESIONAL
                            </div>
                            <table style="border-collapse: collapse;">
                                <tbody>
                                    <tr>
                                        <td style="padding: 5px 20px 5px 10px; vertical-align: middle;">
                                            ${pieFirmaHtmlItem}
                                        </td>
                                        <td style="padding: 5px 10px; vertical-align: middle;">
                                            <img src="${item.firma_final}" alt="Firma" style="max-width: 170px; max-height: 80px; display: block;" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;
                    } else if (item.profesional && item.texto_pie_firma_usuario) {
                        bloqueFirmaRemitente = `
                        <div style="margin-top: 8px; padding: 10px; border: 1px solid #dee2e6; background: #ffffff;">
                            ${pieFirmaHtmlItem}
                        </div>`;
                    }
                    let segmentoRemitente = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">REMITIDO POR</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${item.profesional}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">REGISTRO MÉDICO</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${valorNoAplica(item.registro_medico)}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">CÓDIGO HABILITACIÓN</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${valorNoAplica(item.codigo_habilitacion)}</td>
                                    </tr>
                                </tbody>
                            </table>
                            ${bloqueFirmaRemitente}
                        </div>`;

                    // 4. Tabla de descripción (Ahora va de última)
                    let segmentoDescripcion = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DESCRIPCIÓN / MOTIVO DE REMISIÓN</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                            ${item.descripcion}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    const itemParcial = segmentoInfo + segmentoDatos + segmentoRemitente + segmentoDescripcion + "<hr style='border-top: 2px solid #e0e0e0; margin: 25px 0;'>";

                    consolidadoItems += itemParcial;
                    return null;
                });

                setConsolidado(consolidadoItems);
            })
            .catch(error => {
                console.log(error);
            });
    }




    const handleSubmit = (e) => {

        e.preventDefault();

        if (deshabilitarBotonGuardar || loading) {
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        setDeshabilitarBotonGuardar(true);
        setLoading(true);

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // 🔧 Extraer fecha del campo fechaHora para backend
        let fechaSolo = fecha; // Fallback al valor por defecto
        if (fechaHora) {
            // Extraer solo la fecha (YYYY-MM-DD) del datetime-local
            fechaSolo = fechaHora.split('T')[0];
        }

        const uidRemitente = remitidoPor != null && remitidoPor !== '' ? remitidoPor : userdata.user_id;

        const data = {
            paciente_id: pacienteId,
            remitido_por: nombreProfesional,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            remitido_a: remitidoA,
            direccion: direccion,
            telefono: telefono,
            especialidad: especialidad,
            descripcion: descripcion,
            user_id: uidRemitente,
            fecha: fechaSolo,
            hora_inicial: fechaHora
        };

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        axios.post('/remision', data, config)
            .then(() => {
                setLoading(false);
                setRemitidoA('');
                setDireccion('');
                setTelefono('');
                setEspecialidad('');
                setDescripcion('');
                setFechaHora('');
                setTextoPieFirma('');
                const sel = document.getElementById('remitidoPor');
                if (sel) sel.value = '';
                setRemitidoPor(undefined);
                setErrorlist({});
                cargaritems();
                setTimeout(() => setShowModalConfirmacion(true), 500);
            })
            .catch(error => {
                setLoading(false);
                setDeshabilitarBotonGuardar(false);
                console.log('Error guardando remisión:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                    const errPayload = error.response && error.response.data ? error.response.data : null;
                    const msg = (errPayload && (errPayload.message || errPayload.error)) || error.message || 'No se pudo guardar la remisión.';
                    alert(msg);
                }
            })

    }

    const handleCerrarModalConfirmacion = () => {
        setShowModalConfirmacion(false);
        setDeshabilitarBotonGuardar(false);
        props.guardarCambios('La remisión ha sido guardada exitosamente');
    };


    const verResumen = (ttlResumen, resumenIndividual) => {
        setTituloResumen(ttlResumen);
        setPdfNativoConfigIndividual(construirConfigPdfRemisionNativo(resumenIndividual));

        const segundoNombre = resumenIndividual.segundo_nombre ? resumenIndividual.segundo_nombre : "";
        const segundoApellido = resumenIndividual.segundo_apellido ? resumenIndividual.segundo_apellido : "";

        const nombrePaciente = resumenIndividual.primer_nombre + " " + segundoNombre + " " + resumenIndividual.primer_apellido + " " + segundoApellido;

        const pieFirmaResumen = resumenIndividual.texto_pie_firma_usuario
            ? `<div style="font-size: 10px; color: #6c757d; white-space: pre-line;">${resumenIndividual.texto_pie_firma_usuario}</div>`
            : `<div style="font-size: 10px; color: #6c757d;">RM: ${valorNoAplica(resumenIndividual.registro_medico)} | Cód. Hab: ${valorNoAplica(resumenIndividual.codigo_habilitacion)}</div>`;
        let bloqueFirmaResumen = '';
        if (resumenIndividual.profesional && resumenIndividual.firma_final) {
            bloqueFirmaResumen = `
                <div style="margin-bottom: 12px;">
                    <div style="background-color: #f8f9fa; font-weight: bold; padding: 8px 10px; font-size: 13px; text-align: left; margin-bottom: 5px;">
                        FIRMA DEL PROFESIONAL
                    </div>
                    <table style="border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 5px 20px 5px 10px; vertical-align: middle;">
                                    ${pieFirmaResumen}
                                </td>
                                <td style="padding: 5px 10px; vertical-align: middle;">
                                    <img src="${resumenIndividual.firma_final}" alt="Firma" style="max-width: 170px; max-height: 80px; display: block;" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        } else if (resumenIndividual.profesional && resumenIndividual.texto_pie_firma_usuario) {
            bloqueFirmaResumen = `
                <div style="margin-bottom: 12px; padding: 10px; border: 1px solid #dee2e6; background: #ffffff;">
                    ${pieFirmaResumen}
                </div>`;
        }

        // 🎨 Nuevo estilo con tablas y bandas grises (igual que ModalFormulas.js)
        const contenidoResumen = `
            <div style="font-family: Arial, sans-serif;">
                
                <!-- Banner: REMISIÓN MÉDICA -->
                <div style="margin-bottom: 12px;">
                    <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                        REMISIÓN MÉDICA
                    </div>
                </div>

                <!-- Información del Paciente -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.fecha}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.tipo_documento + ' ' + resumenIndividual.numero_documento}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Datos de la Remisión -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">REMITIDO A</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.remitido_a}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">ESPECIALIDAD</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.especialidad || 'No especificada'}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.direccion || 'No especificada'}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.telefono || 'No especificado'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Profesional que Remite (Invertido: ahora antes de la descripción) -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">REMITIDO POR</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${resumenIndividual.profesional}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">REGISTRO MÉDICO</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${valorNoAplica(resumenIndividual.registro_medico)}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">CÓDIGO HABILITACIÓN</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${valorNoAplica(resumenIndividual.codigo_habilitacion)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                ${bloqueFirmaResumen}

                <!-- Descripción (Invertido: ahora después del profesional) -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DESCRIPCIÓN / MOTIVO DE REMISIÓN</td>
                            </tr>
                            <tr>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                    ${resumenIndividual.descripcion}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>`;

        setContenidoResumenIndividual(contenidoResumen);
        setShowModalResumen(true);
    }


    useEffect(() => {
        cargaritems();

        // Cleanup function to prevent memory leaks
        return () => {
            setHistorial([]);
            setConsolidado('');
            setShowModalResumen(false);
            setShowModalConsolidado(false);
            setPdfNativoConfigIndividual(null);
            setPdfNativoConfigConsolidado(null);
        };
    }, [props.cargarHistorial]);



    const handleProfesionalRemision = (profesionalRemision) => {
        if (!profesionalRemision) {
            setNombreProfesional('');
            setRegistroMedico('');
            setCodigoHabilitacion('');
            setFirmaimg('');
            setTextoPieFirma('');
            return;
        }

        for (let prof of listaProfesionales) {
            if (profesionalRemision == prof.id) {
                setNombreProfesional(prof.name + ' ' + prof.lastname);
                setRegistroMedico(prof.registro_medico ?? '');
                setCodigoHabilitacion(prof.codigo_habilitacion ?? '');
                setFirmaimg(prof.firma_blob || '');
                setTextoPieFirma(prof.texto_pie_firma || '');
                break;
            }
        }
    };


    const descargarPdf = () => {

        var opt = {
            margin: 12,
            filename: `remisiones - consolidado - ${props.docPaciente || 'paciente'}.pdf`,
            image: { type: 'jpeg', quality: 0.97 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        // 🆕 Usar encabezado personalizado si está disponible, eliminar información duplicada del paciente
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // 🔧 ELIMINADA información duplicada del paciente (anamnesis) como en ModalEvolucion.js
        let remisionCompleta = encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif;">' +
            '<h1 style="text-align: center; margin-bottom: 20px;">REMISIONES</h1>' +
            consolidado +
            '</div>';

        // Generar PDF con foliación
        html2pdf().from(remisionCompleta).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación a cada página
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 5, { align: 'center' });
            }

            pdf.save(opt.filename);
        });
    }

    if (loggedIn) {
        return (

            <>
                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="remision">

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Fecha y Hora *</label>
                                                    <div className="input-group">
                                                        <input
                                                            type="datetime-local"
                                                            className="form-control"
                                                            value={fechaHora || ''}
                                                            onChange={(e) => setFechaHora(e.target.value)}
                                                            required
                                                        />
                                                        <div className="input-group-append">
                                                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setFechaHora(formatearFechaHoraParaInput(new Date()))}>
                                                                <i className="fas fa-clock"></i> Actual
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {errorlist.fecha && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.fecha}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="remitidoPor">Remitido por *</label>
                                                    <select name="remitidoPor" className="form-control" id="remitidoPor" onChange={(e) => handleProfesionalRemision(e.target.value)} required>
                                                        <option value="">Seleccione profesional...</option>
                                                        {
                                                            listaProfesionales.map((prof) =>
                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            )
                                                        }
                                                    </select>
                                                    {errorlist.remitido_por && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.remitido_por}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="remitidoA">Remitido a *</label>
                                                    <input type="text" name="remitido-a" className="form-control" id="remitidoA" value={remitidoA} onChange={(e) => setRemitidoA(e.target.value)} required />
                                                    {errorlist.remitido_a && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.remitido_a}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="telefono">Teléfono</label>
                                                    <input type="text" name="telefono" className="form-control" id="telefono" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="direccion">Dirección</label>
                                                    <input type="text" name="direccion" className="form-control" id="direccion" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="especialidad">Especialidad</label>
                                                    <input type="text" name="especialidad" className="form-control" id="especialidad" value={especialidad} onChange={(e) => setEspecialidad(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="descripcion">Descripción *</label>
                                                    <textarea
                                                        name="descripcion"
                                                        className="form-control"
                                                        id="descripcion"
                                                        rows="4"
                                                        required
                                                        value={descripcion}
                                                        onChange={(e) => setDescripcion(e.target.value)}
                                                        placeholder="Ingrese la descripción de la remisión..."
                                                    />
                                                    {errorlist.descripcion && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.descripcion}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card" style={{ marginTop: '12px' }}>
                                        <div className="card-body" style={{ padding: '0.7rem' }}>
                                            <div className="row">
                                                {firmaimg && (
                                                    <div className="col-md-4">
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label>Firma del profesional (remitente)</label>
                                                            <br />
                                                            <img src={firmaimg} className="firma-profesional-hc" alt="" />
                                                        </div>
                                                    </div>
                                                )}
                                                <div className={firmaimg ? 'col-md-8' : 'col-md-12'}>
                                                    <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                        <label>Pie de firma</label>
                                                        <br />
                                                        {textoPieFirma ? (
                                                            <div style={{ whiteSpace: 'pre-line', fontSize: '0.75rem', color: '#495057', lineHeight: '1.6' }}>
                                                                {textoPieFirma}
                                                            </div>
                                                        ) : (
                                                            <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>
                                                                {nombreProfesional || 'Seleccione profesional en "Remitido por"'}
                                                                <br />
                                                                <small>
                                                                    RM: {registroMedico || 'N/A'} | Hab: {codigoHabilitacion || 'N/A'}
                                                                </small>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-secondary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <button type="button" className="btn btn-outline-secondary" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div className="col-md-3">

                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de Remisiones</b>

                                    {
                                        historial.map((item) =>

                                            <div key={item.id} className="timeline-item-container" onClick={() => verResumen('Remisión', item)}>
                                                <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button type="button" className="btn btn-sm btn-outline-secondary btn-resumen-historico" onClick={() => {
                                    setPdfNativoConfigConsolidado(construirConfigPdfRemisionesConsolidadoNativo());
                                    setShowModalConsolidado(true);
                                }}>Ver todo</button>
                                {/*<br />
                                        <button className="btn btn-primary btn-resumen-historico" onClick={descargarPdf}>Descargar</button>*/}

                            </div>
                        </div>

                    </div>
                </section>



                {showModalResumen && (
                    <ModalResumenRemision
                        idModal="modalResumenRemisiones"
                        titulo={tituloResumen}
                        contenido={contenidoResumenIndividual}
                        profesional={profesionalResumenIndividual}
                        registro={registroMedicoResumenIndividual}
                        codigo={codigoHabilitacionResumenIndividual}
                        firma={firmaResumenIndividual}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo={'remision'}
                        docPaciente={props.docPaciente}
                        cliente={client}
                        pdfNativoConfig={pdfNativoConfigIndividual}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        onClose={() => {
                            setShowModalResumen(false);
                            setPdfNativoConfigIndividual(null);
                        }}
                    />
                )}

                {showModalConsolidado && (
                    <ModalResumenRemision
                        idModal="modalConsolidadoRemisiones"
                        titulo="Resumen Remisiones"
                        contenido={consolidado}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo={'historico-remisiones'}
                        docPaciente={props.docPaciente}
                        cliente={client}
                        pdfNativoConfig={pdfNativoConfigConsolidado}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        onClose={() => {
                            setShowModalConsolidado(false);
                            setPdfNativoConfigConsolidado(null);
                        }}
                    />
                )}

                <Modal show={showModalConfirmacion} onHide={handleCerrarModalConfirmacion} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>
                            <i className="fas fa-file-medical mr-1"></i> Remisión Guardada
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-0" style={{ fontSize: '16px' }}>
                            La Remisión ha sido Guardada Exitosamente. Puede abrirla desde el Historial para Vista Previa o PDF.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={handleCerrarModalConfirmacion}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

            </>


        );
    }

    return (
        <Loading />
    );
}
export default ModalRemisiones;